// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"K2-z"};